"use client";

import React from "react";
import { PiggyBank, Armchair, Euro, Users, Flower2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
interface Benefit {
  id: number;
  label: string;
  description: string;
  icon: React.ElementType;
  colorClass: string;
  glowClass: string;
}
const benefits: Benefit[] = [{
  id: 1,
  label: "Lagere kosten",
  description: "Grip op inkoop, loonkosten en operationele kosten.\xA0",
  icon: PiggyBank,
  colorClass: "text-primary",
  glowClass: "bg-primary/20"
}, {
  id: 2,
  label: "Hogere bezetting",
  description: "Meer gasten door slimme campagnes en acties.\xA0",
  icon: Armchair,
  colorClass: "text-primary",
  glowClass: "bg-primary/20"
}, {
  id: 3,
  label: "Betere marges",
  description: "Hogere brutomarge en meer winst overhouden.\xA0",
  icon: Euro,
  colorClass: "text-primary",
  glowClass: "bg-primary/20"
}, {
  id: 4,
  label: "Sterkere teams",
  description: "Minder verloop, betere planning en tevreden medewerkers.",
  icon: Users,
  colorClass: "text-primary",
  glowClass: "bg-primary/20"
}, {
  id: 5,
  label: "Meer rust",
  description: "Minder stress, meer overzicht en focus op wat echt belangrijk is.\xA0",
  icon: Flower2,
  colorClass: "text-primary",
  glowClass: "bg-primary/20"
}];
export default function VictoryMetrics() {
  return <div className="w-full py-12 bg-background">
      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-semibold text-center mb-12 text-foreground">
          Wat levert het jou op?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
          {benefits.map((benefit, i) => {
          const IconComponent = benefit.icon;
          return <Card key={benefit.id} data-index={i} className="w-full text-card-foreground flex flex-col gap-6 rounded-xl py-6 border-none shadow-md hover:shadow-lg transition-shadow bg-background">
                <CardContent className="p-6 flex flex-col items-center text-center">
                  <IconComponent className={`${benefit.colorClass} w-8 h-8 mb-2 md:mb-4`} />
                  <p className="font-bold mb-2">{benefit.label}</p>
                  <p className="text-sm text-muted-foreground">{benefit.description}</p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </div>;
}